var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#BF1616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7826 12.2477C20.9487 12.2477 21.0994 12.3202 21.2186 12.4427C21.3296 12.5735 21.3855 12.736 21.3693 12.9077C21.3693 12.9644 20.9252 18.581 20.6715 20.9451C20.5127 22.3959 19.5774 23.2767 18.1745 23.3009C17.0958 23.3251 16.0414 23.3334 15.0032 23.3334C13.9009 23.3334 12.823 23.3251 11.7767 23.3009C10.4208 23.2684 9.48474 22.3718 9.33399 20.9451C9.07302 18.5726 8.63699 12.9644 8.62889 12.9077C8.62079 12.736 8.6759 12.5735 8.78774 12.4427C8.89796 12.3202 9.05681 12.2477 9.22377 12.2477H20.7826ZM16.7206 6.66675C17.4573 6.66675 18.1154 7.18091 18.3059 7.91424L18.442 8.52256C18.5522 9.01839 18.9818 9.36922 19.4762 9.36922H21.9059C22.2301 9.36922 22.5 9.63838 22.5 9.98088V10.2975C22.5 10.6317 22.2301 10.9092 21.9059 10.9092H8.09488C7.76988 10.9092 7.5 10.6317 7.5 10.2975V9.98088C7.5 9.63838 7.76988 9.36922 8.09488 9.36922H10.5246C11.0182 9.36922 11.4478 9.01839 11.5588 8.5234L11.686 7.95507C11.8838 7.18091 12.5346 6.66675 13.2794 6.66675H16.7206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.6adc4a5b5677ca03c63b5f3aea5ca07a.svg";
export { ForwardRef as ReactComponent };